import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../../contexts/AuthContext'
import TablaPlanteles from "./TablaPlanteles";
import PlantelesCreate from "./PlantelesCreate";
import axios from "axios";
import { Table, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";

function ListadoPlanteles() {
  const { user } = useContext(AuthContext);
  const URL_PLANTELES = process.env.REACT_APP_URL_PLANTELES;
  const PLANTELES_GENERAL = process.env.REACT_APP_PLANTELES_GENERAL;
  const [planteles, setPlanteles] = useState([]);
  let activo;

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

  useEffect(() => {
    axios
      .get(URL_PLANTELES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPlanteles = response.data;
        setPlanteles(allPlanteles);
      })
      .catch((err) => {
        console.log(err);
      });
  },[]);

  return (
    <>
    <Header />
    <br />
    <br />
      <div className="container">
      { user.menu_planteles ?(
        <div className="card col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-folder-open" style={{ marginRight: 8, color: "#14b8a6" }} />
                Planteles
              </h3>
            </div>
            <div className="page-actions">
              <Button size="sm" color="success" onClick={toggleCreate}>
                <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo Plantel
              </Button>
            </div>
          </div>
                <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
                  <thead>
                    <tr>
                    <th className="tituloTabla">Activo</th>
                      <th className="tituloTabla">
                        Nombre
                      </th><th className="tituloTabla">
                        Telefono
                      </th>
                      <th className="tituloTabla">
                        Editar
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    {planteles.map((p) => {
                      if(p._id != PLANTELES_GENERAL){
                        if (p.is_active) {
                          activo = "Si";
                        } else {
                          activo = "No";
                        }
                      return (
                        <tr>
                          <TablaPlanteles
                            name={p.name}
                            telefono={p.telefono}
                            _id={p._id}
                            direccion={p.direccion}
                            is_active={p.is_active}
                            activo={activo}
                          />
                        </tr>
                      )};
                    })}
                  </tbody>
                </Table>
        </div>
        ): undefined }
      </div>
      <br />

      {/* Modal de alta */}
      <Modal size="sm" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <i className="fas fa-plus" style={{ marginRight: 8 }} />
          Nuevo Plantel
        </ModalHeader>
        <ModalBody>
          <PlantelesCreate />
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoPlanteles;
